import React from 'react';
import { useSearchParams } from 'react-router-dom';
import * as ds from '../../constants/dashboardStyles';

// Keeps the active tab in the URL (?tab=quotes) rather than component state, so
// a refresh, a back button, or a pasted link all land where you expect.
// `replace` keeps tab switching out of the browser history.
export function useDashboardTab(defaultTab) {
  const [searchParams, setSearchParams] = useSearchParams();
  const active = searchParams.get('tab') || defaultTab;
  const setActive = (tab) => setSearchParams(tab === defaultTab ? {} : { tab }, { replace: true });
  return [active, setActive];
}

// `tabs` is [{ id, label, count }] — count renders as an unread badge when > 0.
export default function DashboardTabs({ tabs, active, onChange }) {
  return (
    <div style={ds.tabRow} role="tablist">
      {tabs.map(({ id, label, count }) => {
        const isActive = id === active;
        return (
          <button
            key={id}
            type="button"
            role="tab"
            aria-selected={isActive}
            className="dash-tab"
            style={{ ...ds.tab, ...(isActive ? ds.tabActive : {}) }}
            onClick={() => onChange(id)}
          >
            {label}
            {count > 0 && <span style={ds.tabCount}>{count}</span>}
          </button>
        );
      })}
    </div>
  );
}
